import React, { useEffect, useState } from "react";
import fallbackPlaceholderImage from "assets/images/fallback_placeholder_img.svg";

type ImageWithFallbackProps = {
    src?: string | null;
    alt: string;
    className?: string;
};

function ImageWithFallback({ src, alt, className }: ImageWithFallbackProps) {
    const [imageSrc, setImageSrc] = useState(src || fallbackPlaceholderImage);

    useEffect(() => {
        setImageSrc(src || fallbackPlaceholderImage);
    }, [src]);

    const handleError = (event: React.SyntheticEvent<HTMLImageElement>) => {
        event.currentTarget.onerror = null;
        setImageSrc(fallbackPlaceholderImage);
    };

    return <img src={imageSrc} alt={alt} className={className} onError={handleError} />;
}

export default ImageWithFallback;
